module.exports = __webpack_public_path__ + "static/media/logoPrivate.216f95bb.svg";